import { Grid } from '@mui/material'
import { RegistroSolicitudFirma } from './registroSolicitudFirma'
import { FirmaElectronica } from './firmaElectronica'
import { DocumentosSolicitudFirma } from './documentosSolicitudFirma'

export const DetalleFirma = () => {
  // DjFau1pRNfggQjZqzUbb

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
         <RegistroSolicitudFirma />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
         <DocumentosSolicitudFirma />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
         <FirmaElectronica/>
      </Grid>
    </Grid>
  )
}
